import { useQuery } from '@tanstack/react-query';

import { axiosGetV3 } from '../../api/axios-handler';

export const domainQueryKeys = {
  current: ['domains', 'current'] as const,
};

export type CurrentDomain = {
  id: number;
  key: string;
  name: string;
  primary_domain_url: string;
  phone_number: string | null;
};

const fetchCurrentDomain = async (): Promise<CurrentDomain> => {
  const res = await axiosGetV3('/domains/current', {});
  return res.data as CurrentDomain;
};

export const useCurrentDomain = (enabled: boolean = true) => {
  return useQuery<CurrentDomain>(domainQueryKeys.current, fetchCurrentDomain, {
    staleTime: 1000 * 60 * 10,
    enabled,
  });
};
